import { cn } from '@exam-room/utils';

import { MathRenderer } from '../../../components';
import ResizableLayout from '../resizable-layout';

interface QuestionPaperProps extends React.ComponentPropsWithoutRef<'div'> {
  size: 'md' | 'lg';
  article?: string;
}

export function QuestionPaper(props: QuestionPaperProps) {
  const { className, children, article, ...restProps } = props;
  if (article) {
    return (
      <MathRenderer
        className={cn(
          'mx-auto max-w-4xl p-10 pt-6 whitespace-pre-line [&>*]:list-inside [&>*]:list-disc [&>ul]:pl-4',
          className,
        )}
        content={article}
      />
    );
  }
  return (
    <div
      className={cn(
        'mx-auto max-w-4xl p-10 pt-6 whitespace-pre-line [&>*]:list-inside [&>*]:list-disc [&>ul]:pl-4',
        className,
      )}
      {...restProps}
    >
      {children}
    </div>
  );
}

interface QuestionLayoutProps extends React.ComponentPropsWithoutRef<'div'> {
  article?: React.ReactNode;
}

export default function QuestionLayout(props: QuestionLayoutProps) {
  const { children, article, className, ...restProps } = props;

  if (article) {
    return (
      <ResizableLayout
        className={className}
        left={article}
        right={<QuestionPaper size='md'>{children}</QuestionPaper>}
        {...restProps}
      />
    );
  }
  return (
    <div className='no-scrollbar h-full w-full overflow-scroll'>
      <QuestionPaper size='lg' className={className} {...restProps}>
        {children}
      </QuestionPaper>
    </div>
  );
}
